import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import CssBaseline from '@material-ui/core/CssBaseline';
import List from '@material-ui/core/List';
import IconButton from '@material-ui/core/IconButton';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import DashboardIcon from '@material-ui/icons/Dashboard';
import PersonIcon from '@material-ui/icons/Person';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import BookIcon from '@material-ui/icons/Book';
import GroupIcon from '@material-ui/icons/Group';
import AssessmentIcon from '@material-ui/icons/Assessment';
import AssignmentReturnIcon from '@material-ui/icons/AssignmentReturn';
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';
import NoteAddIcon from '@material-ui/icons/NoteAdd';
import { useAuthDispatch, useAuthState } from '../../../Context';
import { USER_ROLES } from '../../../utils/constants';
import {
  isLearningHubAvailable,
  LEARNING_HUB_AVAILABILITY_EVENT,
} from '../../../utils/learningHubAvailability';
import { useLocation } from 'react-router-dom';
import { UserPath } from '../../../Routes/routePaths';
import EventAvailableIcon from '@material-ui/icons/EventAvailable';
import MenuItems from './MenuItems';
import { useHistory } from 'react-router';
import variables from '../../../Sys/variable.scss';
import EqualizerIcon from '@material-ui/icons/Equalizer';
import AssignmentIcon from '@material-ui/icons/Assignment';
import CollectionsBookmarkIcon from '@material-ui/icons/CollectionsBookmark';
import MenuBookIcon from '@material-ui/icons/MenuBook';
import LocalLibraryIcon from '@material-ui/icons/LocalLibrary';
import LocalLibraryOutlinedIcon from '@material-ui/icons/LocalLibraryOutlined';
import DvrIcon from '@material-ui/icons/Dvr';
export const SIDEBAR_WIDTH = 220;
export const SIDEBAR_COLLAPSED_WIDTH = 72;
const drawerWidth = SIDEBAR_WIDTH;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'none',
    position: 'relative',
    height: (props) => (props.constrainHeight ? '100%' : undefined),
    minHeight: (props) => (props.constrainHeight ? 0 : undefined),
    alignSelf: (props) => (props.constrainHeight ? 'stretch' : undefined),
    '@media (min-width: 1280px)': {
      display: 'flex',
    },
    '&:hover $collapseToggleBtn, &:focus-within $collapseToggleBtn': {
      opacity: 1,
      visibility: 'visible',
    },
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    height: (props) => (props.constrainHeight ? '100%' : undefined),
    transition: 'width 0.2s ease',
    [theme.breakpoints.down('sm')]: {
      width: drawerWidth,
    },
  },
  drawerPaper: {
    width: drawerWidth,
    background: variables.sidebarColor,
    border: '0',
    minHeight: (props) => (props.constrainHeight ? 0 : '100vh'),
    height: (props) => (props.constrainHeight ? '100%' : undefined),
    transition: 'width 0.2s ease',
    overflowX: 'hidden',
    [theme.breakpoints.up('sm')]: {
      position: 'relative',
    },
  },
  drawerPaperMobile: {
    width: drawerWidth,
    background: variables.sidebarColor,
    border: '0',
  },
  toolbar: {
    ...theme.mixins.toolbar,
    background: variables.sidebarColor,
    minHeight: 95,
    [theme.breakpoints.down('sm')]: {
      minHeight: 64,
    },
  },
  drawerContainer: {
    overflow: 'auto',
    background: variables.sidebarColor,
  },
  collapseToggleBtn: {
    position: 'absolute',
    top: 24,
    right: -14,
    // MUI's Drawer Paper always carries zIndex: theme.zIndex.drawer (1200)
    // internally, even for the permanent variant, so this must clear that
    // to render above the sidebar instead of behind it.
    zIndex: theme.zIndex.drawer + 1,
    width: 28,
    height: 28,
    backgroundColor: '#fff',
    border: `1px solid ${variables.darkThemeText}`,
    boxShadow: '0px 2px 6px rgba(0,0,0,0.2)',
    color: variables.darkThemeText,
    opacity: 0,
    visibility: 'hidden',
    transition: 'opacity 0.15s ease',
    '&:hover': {
      backgroundColor: '#f0f0f0',
    },
    '&:focus': {
      opacity: 1,
      visibility: 'visible',
    },
  },
}));

const superAdminMenus = [
  {
    title: 'Dashboard',
    icon: <DashboardIcon />,
    active: '/dashboard',
  },
  {
    title: 'Administrators',
    icon: <PersonIcon />,
    active: '/administrators',
  },
  {
    title: 'Customer Onboarding',
    icon: <PersonAddIcon />,
    active: '/flowcustomer',
  },
  {
    title: 'Customers',
    icon: <GroupIcon />,
    active: '/customers',
  },
  {
    title: 'Users',
    icon: <PersonIcon />,
    active: '/users',
  },
  {
    title: 'Courses',
    icon: <BookIcon />,
    active: '/courses',
  },
  {
    title: 'Assessments',
    icon: <AssessmentIcon />,
    active: '/myassessments',
  },
  {
    title: 'Experiments',
    icon: <AssignmentReturnIcon />,
    active: '/experiments',
  },
  {
    title: 'Deployments',
    icon: <BookIcon />,
    active: '/deployments',
  },
  {
    title: 'Reporting',
    icon: <LibraryBooksIcon />,
    active: '/reporting',
    submenus: [
      {
        title: 'Overview',
        icon: <LibraryBooksIcon />,
        active: '/reporting/overview',
      },
      {
        title: 'Learning as a service',
        icon: <LibraryBooksIcon />,
        active: '/reporting/learning-service',
      },
      // {
      //   title: 'Digital Readiness',
      //   icon: <LibraryBooksIcon />,
      //   active: '/reporting/digital-readliness',
      // },
      {
        title: 'Digital Talent Maturity Model',
        icon: <LibraryBooksIcon />,
        active: '/reporting/digital-talent-maturity',
      },
      {
        title: 'AI Maturity Model',
        icon: <LibraryBooksIcon />,
        active: '/reporting/digital-ai-maturity',
      },
    ]
  }
];
const customerAdminMenus = [
  {
    title: 'Dashboard',
    icon: <DashboardIcon />,
    active: '/dashboard',
  },
  {
    title: 'Users',
    icon: <PersonIcon />,
    active: '/users',
  },
  {
    title: 'Licenses',
    icon: <NoteAddIcon />,
    active: '/licenses',
  },
  {
    title: 'Calendar',
    icon: <EventAvailableIcon />,
    active: '/calendar',
  },
  {
    title: 'Course Requests',
    icon: <BookIcon />,
    active: '/course-requests',
  },
  {
    title: 'Learning Hub requests',
    icon: <LocalLibraryOutlinedIcon />,
    active: '/learning-hub-requests',
  },
  {
    title: 'Reporting',
    icon: <LibraryBooksIcon />,
    active: '/reporting',
    submenus: [
      {
        title: 'Overview',
        icon: <LibraryBooksIcon />,
        active: '/reporting/overview',
      },
      {
        title: 'Learning as a service',
        icon: <LibraryBooksIcon />,
        active: '/reporting/learning-service',
      },
      // {
      //   title: 'Digital Readiness',
      //   icon: <LibraryBooksIcon />,
      //   active: '/reporting/digital-readliness',
      // },
      {
        title: 'Digital Talent Maturity Model',
        icon: <LibraryBooksIcon />,
        active: '/reporting/digital-talent-maturity',
      },
      {
        title: 'AI Maturity Model',
        icon: <LibraryBooksIcon />,
        active: '/reporting/digital-ai-maturity',
      },
    ]
  }];
const CSMAdminMenus = [
  {
    title: 'Dashboard',
    icon: <DashboardIcon />,
    active: '/dashboard',
  },
  {
    title: 'Users',
    icon: <PersonIcon />,
    active: '/users',
  },
  {
    title: 'Learning Hub requests',
    icon: <LocalLibraryOutlinedIcon />,
    active: '/learning-hub-requests',
  },
  {
    title: 'Reporting',
    icon: <LibraryBooksIcon />,
    active: '/reporting',
    submenus: [
      {
        title: 'Overview',
        icon: <LibraryBooksIcon />,
        active: '/reporting/overview',
      },
      {
        title: 'Learning as a service',
        icon: <LibraryBooksIcon />,
        active: '/reporting/learning-service',
      },
      // {
      //   title: 'Digital Readiness',
      //   icon: <LibraryBooksIcon />,
      //   active: '/reporting/digital-readliness',
      // },
      {
        title: 'Digital Talent Maturity Model',
        icon: <LibraryBooksIcon />,
        active: '/reporting/digital-talent-maturity',
      },
      {
        title: 'AI Maturity Model',
        icon: <LibraryBooksIcon />,
        active: '/reporting/digital-ai-maturity',
      },
    ]
  }];
const userAdminMenus = [
  {
    title: 'Dashboard',
    icon: <DashboardIcon />,
    active: '/dashboard',
  },
  // {
  //   title: 'Assessments',
  //   icon: <AssessmentIcon />,
  //   active: '/assessments',
  // },
  {
    title: 'My Courses',
    icon: <CollectionsBookmarkIcon />,
    active: UserPath.RegisteredCourses,
    alsoActive: [UserPath.MyLearningHubCourses],
  },
  {
    title: 'Learning Hub',
    icon: <LocalLibraryIcon />,
    active: '/learning-hub',
    badge: 'NEW',
  },
  {
    title: 'Course Catalogue',
    icon: <MenuBookIcon />,
    active: '/skill-transformation/course-catalogue',
  },
  // {
  //   title: 'Experiments and Testing',
  //   icon: <AssignmentIcon />,
  //   active: '/experiments-and-testing',
  // },
  {
    title: 'Calendar',
    icon: <EventAvailableIcon />,
    active: '/calendar',
  },
  {
    title: 'Reporting',
    icon: <AssessmentIcon />,
    active: '/reporting',
    submenus: [
      {
        title: 'Overview',
        icon: <EqualizerIcon />,
        active: '/reporting/overview',
      },
      {
        title: 'Learning as a service',
        icon: <EqualizerIcon />,
        active: '/reporting/learning-service',
      },
      // {
      //   title: 'Digital Readiness',
      //   icon: <EqualizerIcon />,
      //   active: '/reporting/digital-readliness',
      // },
      {
        title: 'Digital Talent Maturity Model',
        icon: <LibraryBooksIcon />,
        active: '/reporting/digital-talent-maturity',
      },
      {
        title: 'AI Maturity Model',
        icon: <LibraryBooksIcon />,
        active: '/reporting/digital-ai-maturity',
      },
    ]
  }
];

function getMenuItemsByRole(role) {
  let getRole = localStorage.getItem('role').trim();
  if (!getRole) {
    localStorage.setItem("role", role)
  }
  if (getRole === USER_ROLES.SUPER_ADMIN) {
    return superAdminMenus;
  } else if (getRole === USER_ROLES.USER) {
    return userAdminMenus;
  } else if (getRole === USER_ROLES.CSM_ADMIN) {
    return CSMAdminMenus
  } else {
    return customerAdminMenus;
  }
}

const Sidebar = ({ mobileOpen, onMobileClose, isMobile, collapsed = false, onToggleCollapse = () => {}, constrainHeight = false }) => {
  const history = useHistory();
  const location = useLocation();
  const classes = useStyles({ constrainHeight });
  const dispatch = useAuthDispatch();
  const { userDetails } = useAuthState(dispatch);
  const isUserRole = (userDetails?.role || USER_ROLES.USER) === USER_ROLES.USER;
  const [showLearningHub, setShowLearningHub] = React.useState(
    () => isUserRole && isLearningHubAvailable()
  );

  React.useEffect(() => {
    if (!isUserRole) {
      setShowLearningHub(false);
      return;
    }

    setShowLearningHub(isLearningHubAvailable());

    const handleAvailabilityChange = (event) => {
      setShowLearningHub(event.detail.available);
    };

    window.addEventListener(LEARNING_HUB_AVAILABILITY_EVENT, handleAvailabilityChange);
    return () => {
      window.removeEventListener(LEARNING_HUB_AVAILABILITY_EVENT, handleAvailabilityChange);
    };
  }, [isUserRole]);

  const menuItems = getMenuItemsByRole(userDetails?.role || USER_ROLES.USER).filter((item) => {
    if (item.title !== 'Learning Hub') {
      return true;
    }

    return showLearningHub;
  });

  const handleItemClick = (path) => {
    if (location.pathname === path) {
      history.replace({
        pathname: path,
        search: location.search,
        hash: location.hash,
        state: {
          ...(location.state && typeof location.state === 'object' ? location.state : {}),
          sidebarNavAt: Date.now(),
        },
      });
    } else {
      history.push({ pathname: path });
    }
    if (isMobile) {
      onMobileClose();
    }
  }

  const renderDrawerContent = (isCollapsed) => (
    <div className={classes.drawerContainer}>
      <div className={classes.toolbar} />
      <List style={{ background: variables.sidebarColor }}>
        {menuItems.map((item, index) => (
          <MenuItems
            key={index}
            menuItems={item}
            index={index}
            handleItemClick={handleItemClick}
            location={location}
            collapsed={isCollapsed}
            onRequestExpand={onToggleCollapse}
          />
        ))}
      </List>
    </div>
  );

  const desktopWidth = collapsed ? SIDEBAR_COLLAPSED_WIDTH : SIDEBAR_WIDTH;

  return (
    <>
      <CssBaseline />
      {/* Desktop drawer */}
      <nav className={classes.root} aria-label="navigation">
        <Drawer
          className={classes.drawer}
          style={{ width: desktopWidth }}
          variant="permanent"
          classes={{
            paper: classes.drawerPaper,
          }}
          PaperProps={{ style: { width: desktopWidth, ...(constrainHeight ? { height: '100%', minHeight: 0 } : {}) } }}
        >
          {renderDrawerContent(collapsed)}
        </Drawer>
        <IconButton
          size="small"
          className={classes.collapseToggleBtn}
          onClick={onToggleCollapse}
          aria-label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
        >
          {collapsed ? (
            <ChevronRightIcon style={{ color: variables.darkThemeText }} />
          ) : (
            <ChevronLeftIcon style={{ color: variables.darkThemeText }} />
          )}
        </IconButton>
      </nav>
      {/* Mobile drawer */}
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={onMobileClose}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
        classes={{
          paper: classes.drawerPaperMobile,
        }}
      >
        {renderDrawerContent(false)}
      </Drawer>
    </>
  );
}

export default Sidebar;